module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "foreword"
    }
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9"
    }
  }, [_c('strong', [_vm._v("FOREWORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagea"
  }, [_c('img', {
    staticClass: "in100",
    attrs: {
      "alt": "Image",
      "src": "images/bar.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I’ve written seventeen cookbooks. Some of my books have taken years to write, with extensive research and many recipes. Others are smaller, single-subject recipe books. My first book "), _c('em', [_vm._v("From Tapas to Meze")]), _vm._v(" was my firstborn and continues to hold me by the heartstrings. My most recent book, "), _c('em', [_vm._v("Kitchen Gypsy: Recipes and Stories from a Lifelong Romance with Food")]), _vm._v(" has been a pure passion project near and dear to my soul. And it’s Grace Parisi I have to thank for bringing me into this most recent project.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Let me back up a little bit! I’ve known Grace for years. At first, it was her sound reputation I knew from her years working at "), _c('em', [_vm._v("Food & Wine")]), _vm._v(" magazine. Like everyone, I held her name with the highest regard. A few years later, I met Grace in person when we worked on a story together for the magazine. She was everything I’d heard—smart and talented.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I hadn’t seen Grace for a while, and then a couple of years ago we sat together at an industry dinner in Chicago.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“You two should do a book together,” Grace said as she generously introduced me to the editor-in-chief at Oxmoor House.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("That’s how "), _c('em', [_vm._v("Kitchen Gypsy")]), _vm._v(" began, and what transpired was magical. Grace and I worked closely on my book. She traveled to San Francisco several times to test recipes and style the recipes. As we worked side by side, I marveled at her creativity, patience, perseverance, and genuine congeniality.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("What Grace brings to the table every time she jumps into a project is her intelligence, expertise, and passion. Take this book about pickles, for example. Reading the recipes will make you want to run into your kitchen and cook up a batch of Pickled Plum Tomatoes with Chipotle, Spicy Bread-and-Butter Pickles, or Lime-Chile Pickled Pineapple! And that’s what a good cookbook is supposed to do, right?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_c('span', {
    staticClass: "f5"
  }, [_vm._v("JOANNE WEIR")])]), _c('br'), _c('em', [_vm._v("Chef, teacher, television personality,"), _c('br'), _vm._v("and James Beard Award–winning cookbook author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d21cd90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/foreword.vue
// module id = 75
// module chunks = 0